export const billingFormTestId = "components/fragments/argyle/billing-form";
export const billingFormLabelTestId = "components/fragments/argyle/billing-form/label";
export const billingFormElementsTestId = "components/fragments/argyle/billing-form/elements";
export const billingFormId = "components/fragments/argyle/billing-form";
